/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaUserApiResponse
 */
export interface MediaUserApiResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof MediaUserApiResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof MediaUserApiResponse
     */
    message: string;
}

export function MediaUserApiResponseFromJSON(json: any): MediaUserApiResponse {
    return MediaUserApiResponseFromJSONTyped(json, false);
}

export function MediaUserApiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaUserApiResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function MediaUserApiResponseToJSON(value?: MediaUserApiResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

